"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mohole = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var Mohole = (function (_super) {
    __extends(Mohole, _super);
    function Mohole() {
        return _super.call(this, {
            name: CardName_1.CardName.MOHOLE,
            tags: [Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ heat: 3 }),
            metadata: {
                cardNumber: 'P22',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(3); }).br;
                    b.heat(3);
                }),
                description: 'Increase your heat production 3 steps. Gain 3 heat.',
            },
        }) || this;
    }
    Mohole.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 3);
        player.heat += 3;
        return undefined;
    };
    return Mohole;
}(PreludeCard_1.PreludeCard));
exports.Mohole = Mohole;
